export const STORE_PROFILE_ID_METHOD = 'ProfileInterface.v1_0.StoreProfileIdMethod';
export const PROFILE_ID = 'profileId';
